var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[(_vm.getNavStatus)?_c('div',{staticClass:"sidebar-backdrop",on:{"click":_vm.toggleNav}}):_vm._e(),_c('transition',{attrs:{"name":"slide"}},[(_vm.getNavStatus)?_c('div',{staticClass:"sidebar-panel"},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }